import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class TreeNode extends React.Component {
  render() {
    const {
      node,
      itemKeyTitle,
      withLink,
      withKeyId,
      itemKeyId,
      itemLinkPrefix,
      itemLinkSuffix
    } = this.props;

    let element = null;
    if (withLink) {
      const linkItem = `${itemLinkPrefix}${
        withKeyId ? node[itemKeyId] : ""
      }${itemLinkSuffix}`;
      element = <Link to={linkItem}>{node[itemKeyTitle]}</Link>;
    } else {
      element = node[itemKeyTitle];
    }

    return (
      <li>
        <div>{element}</div>

        {this.renderChildren()}
      </li>
    );
  }

  renderChildren() {
    const { node } = this.props;

    let children = node.children;
    if (!Array.isArray(children)) {
      children = children ? [children] : [];
    }

    return (
      <ul>
        {children.map((child, index) => (
          <TreeNode
            key={child.id || index}
            node={child}
            itemKeyTitle={this.props.itemKeyTitle}
            withLink={this.props.withLink}
            withKeyId={this.props.withKeyId}
            itemKeyId={this.props.itemKeyId}
            itemLinkPrefix={this.props.itemLinkPrefix}
            itemLinkSuffix={this.props.itemLinkSuffix}
          />
        ))}
      </ul>
    );
  }
}

TreeNode.propTypes = {
  node: PropTypes.object.isRequired,
  itemKeyTitle: PropTypes.string.isRequired,
  withLink: PropTypes.bool.isRequired,
  withKeyId: PropTypes.bool.isRequired,
  itemKeyId: PropTypes.string.isRequired,
  itemLinkPrefix: PropTypes.string.isRequired,
  itemLinkSuffix: PropTypes.string.isRequired
};

export default TreeNode;
